import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="yg-footer" aria-label="Site footer">
      <div className="yg-footer-links">
        <Link to="/privacy" aria-label="Privacy policy">Privacy</Link>
        <Link to="/terms" aria-label="Terms of service">Terms</Link>
      </div>
      <span className="yg-footer-brand">Yahoogle · AV Agency</span>
    </footer>
  );
}
